import React from "react";

const FormLayoutSeparator = () => {
    return (
        <div className="form-layout__separator"/>
    );
};

export default FormLayoutSeparator;
